import { deserializeURLSearchParams, validateParams } from "@/lib/utils";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import z from "zod";

export function useStep() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  const schema = z.object({
    step: z.preprocess(
      (val) => (val ? Number(val) : undefined),
      z.number().int().positive().optional(),
    ),
  });

  const { step = 1 } = validateParams(
    schema,
    deserializeURLSearchParams(searchParams.toString()),
  );

  const handleStepChange = (nextStep: number) => {
    const params = new URLSearchParams(searchParams);

    // Tabs are scoped to a step; avoid leaking tab state across steps.
    params.delete("t");

    if (nextStep > 1) {
      params.set("step", String(nextStep));
    } else {
      params.delete("step");
    }

    router.replace(`${pathname}?${params.toString()}`, {
      scroll: false,
    });
  };

  return {
    step,
    handleStepChange,
  };
}
